export const url = '/promo/quota';

export const optionHeaderText = 'Действия';
